import React, { useCallback, useEffect, useState } from "react";

import AsideMenu from "./AsideMenu";
import MainContent from "./MainContent";
import DashboardTopbar from "./DashboardTopbar";
import DashboardFooter from "./DashboardFooter";

import { useAsideMenu } from "../../contexts/AsideMenuContext";
import { getSectionById } from "../../services/sectionsServices";

const DEFAULT_SECTION_INFO = {
  logo: "",
  nom: "MonAppliAsso",
  discipline: "Administration",
};

const DashboardAdmin = () => {
  const { isOpen } = useAsideMenu();

  const [userInfo, setUserInfo] = useState(null);
  const [activeSectionId, setActiveSectionId] = useState(null);
  const [sectionInfo, setSectionInfo] = useState(DEFAULT_SECTION_INFO);

  const fetchSectionSettings = useCallback(async (sectionId) => {
    if (!sectionId) {
      setSectionInfo(DEFAULT_SECTION_INFO);
      return;
    }

    try {
      const section = await getSectionById(sectionId);

      setSectionInfo({
        logo: section?.logo_section || section?.photoURL || "",
        nom: section?.nom_section || "MonAppliAsso",
        discipline: section?.discipline_section || "Administration",
      });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des paramètres de la section:",
        error
      );

      setSectionInfo(DEFAULT_SECTION_INFO);
    }
  }, []);

  useEffect(() => {
    let storedUser = null;

    try {
      storedUser = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      storedUser = null;
    }

    if (!storedUser) {
      window.location.href = "/login";
      return;
    }

    setUserInfo(storedUser);

    const isAdmin = Number(storedUser.role_id) === 1;

    const storedAdminSectionId = localStorage.getItem(
      "admin_active_section_id"
    );

    const initialSectionId = isAdmin
      ? storedAdminSectionId || storedUser.section_id
      : storedUser.section_id;

    if (initialSectionId) {
      setActiveSectionId(Number(initialSectionId));
      fetchSectionSettings(initialSectionId);
    }
  }, [fetchSectionSettings]);

  const handleActiveSectionChange = useCallback(
    async (section) => {
      if (!section?.id) return;

      const nextSectionId = Number(section.id);

      setActiveSectionId(nextSectionId);

      localStorage.setItem("admin_active_section_id", String(nextSectionId));

      setSectionInfo({
        logo: section.logo_section || section.photoURL || "",
        nom: section.nom_section || "MonAppliAsso",
        discipline: section.discipline_section || "Administration",
      });

      await fetchSectionSettings(nextSectionId);
    },
    [fetchSectionSettings]
  );

  const contentSpacing = isOpen ? "lg:pl-72" : "lg:pl-20";

  if (!userInfo) return null;

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-white">
      <AsideMenu
        userInfo={userInfo}
        sectionInfo={sectionInfo}
        activeSectionId={activeSectionId}
        onActiveSectionChange={handleActiveSectionChange}
      />

      <div
        className={[
          "flex min-h-screen flex-col transition-all duration-300",
          contentSpacing,
        ].join(" ")}
      >
        <DashboardTopbar
          userInfo={userInfo}
          sectionInfo={sectionInfo}
          activeSectionId={activeSectionId}
        />

        <main className="flex-1 px-4 py-5 sm:px-6 lg:px-8">
          <MainContent sectionId={activeSectionId} />
        </main>

        <DashboardFooter />
      </div>
    </div>
  );
};

export default DashboardAdmin;